export const GET_GXT_LIST_DATA = 'GET_GXT_LIST_DATA'
export const GET_GXT_DATA = 'GET_GXT_DATA'
export const GET_GXT_DOCUMENT = 'GET_GXT_DOCUMENT'
export const GXT_DOC_LOADING = 'GXT_DOC_LOADING'
export const SET_GXT_LOADING = 'SET_GXT_LOADING'
export const RESET_GXT_MODAL = 'RESET_GXT_MODAL'
export const CLEAR_GXT = 'CLEAR_GXT'
